<button
  type="button"
  class="flex w-full justify-center cursor-pointer bg-transparent border-none p-0"
  [attr.aria-label]="config().ariaLabel || config().alt"
  [disabled]="disabled()"
  (click)="onClick()"
>
  <img
    [src]="config().src"
    [alt]="config().alt"
    class="h-11"
  />
</button>
